/**
 * รายชื่อพนักงานขาดงานไม่ทราบสาเหตุ + จำนวนวัน (drill-down จากการ์ด AI "ขาดงานไม่ทราบสาเหตุ")
 * แหล่งข้อมูล: monthly_summary.absent_days > 0 (งวดที่เลือก) — ตรงกับกฎ UNEXPLAINED_ABSENCE
 */
import { useSearchParams } from 'react-router-dom';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useAbsenceReport } from '../../hooks';
import { UserX, AlertTriangle } from 'lucide-react';

function thisPeriod(): string {
  return new Date(Date.now() + 7 * 3600_000).toISOString().slice(0, 7);
}

export function HRAbsenceReport() {
  const [sp] = useSearchParams();
  const period = sp.get('period') || thisPeriod();
  const { data, isLoading } = useAbsenceReport(period);

  return (
    <AdminLayout title="พนักงานขาดงานไม่ทราบสาเหตุ">
      {isLoading || !data ? (
        <p className="py-8 text-center text-gray-500">กำลังโหลด…</p>
      ) : (
        <div className="space-y-4">
          <div className="card p-4 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center shrink-0">
              <AlertTriangle className="w-5 h-5 text-amber-600" />
            </div>
            <div className="text-sm">
              <div className="font-semibold">งวด {period}</div>
              <div className="text-gray-500">
                ขาดงานไม่ทราบสาเหตุ <b className="text-amber-700">{data.count}</b> คน · รวม <b className="text-amber-700">{data.total_days}</b> วัน
              </div>
            </div>
          </div>

          <div className="card p-2">
            <p className="px-2 py-1.5 text-[12px] text-gray-500">
              นับจากวันที่ไม่มีสแกนเข้างาน + ไม่มีใบลาอนุมัติ + ไม่ใช่วันหยุด (เฝ้าระวัง §119 ขาดติดต่อ 3 วัน)
            </p>
            {data.employees.length === 0 ? (
              <p className="py-8 text-center text-gray-500 text-sm">ไม่มีพนักงานขาดงานในงวดนี้ 🎉</p>
            ) : (
              <div className="divide-y divide-gray-100">
                {data.employees.map((e) => (
                  <div key={e.emp_code} className="flex items-center gap-3 px-2 py-2.5">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center shrink-0">
                      <UserX className="w-4 h-4 text-gray-400" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm font-medium truncate">{e.name}</div>
                      <div className="text-[11px] text-gray-400">{e.emp_code}</div>
                    </div>
                    <span className={`shrink-0 text-sm font-semibold ${e.absent_days >= 3 ? 'text-red-600' : 'text-amber-600'}`}>
                      {e.absent_days} วัน
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
